function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useState } from "react";
import ImageGallery from 'react-image-gallery';
import Lightbox from 'react-image-lightbox';
export default function SliderImages(_ref) {
  var images = _ref.images,
    linkTo = _ref.linkTo,
    extraClass = _ref.extraClass,
    showThumbnails = _ref.showThumbnails,
    showFullscreenButton = _ref.showFullscreenButton,
    showNav = _ref.showNav,
    showBullets = _ref.showBullets,
    thumbnailPosition = _ref.thumbnailPosition,
    lightbox = _ref.lightbox;
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    photoIndex = _useState2[0],
    setPhotoIndex = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isOpen = _useState4[0],
    setIsOpen = _useState4[1];
  var styles = null;
  if (lightbox) {
    styles = /*#__PURE__*/React.createElement("style", {
      dangerouslySetInnerHTML: {
        __html: "\n                  .image-gallery-image { cursor: pointer }\n               "
      }
    });
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "slider-images",
    style: {
      position: 'relative'
    }
  }, styles, /*#__PURE__*/React.createElement(ImageGallery, {
    items: images,
    thumbnailPosition: thumbnailPosition,
    showNav: showNav,
    showThumbnails: images.length > 1 ? showThumbnails : false,
    showFullscreenButton: false,
    lazyLoad: true,
    showPlayButton: false,
    onClick: function onClick() {
      return lightbox ? setIsOpen(true) : {};
    }
  }), lightbox && /*#__PURE__*/React.createElement("div", {
    className: "lightbox-wrapper"
  }, isOpen && /*#__PURE__*/React.createElement(Lightbox, {
    mainSrc: images[photoIndex].fullscreen,
    nextSrc: images[(photoIndex + 1) % images.length].fullscreen,
    prevSrc: images[(photoIndex + images.length - 1) % images.length].fullscreen,
    enableZoom: true,
    onCloseRequest: function onCloseRequest() {
      return setIsOpen(false);
    },
    onMovePrevRequest: function onMovePrevRequest() {
      return setPhotoIndex((photoIndex + images.length - 1) % images.length);
    },
    onMoveNextRequest: function onMoveNextRequest() {
      return setPhotoIndex((photoIndex + 1) % images.length);
    }
  })));
}

// Available Props
// infinite: Boolean
// lazyLoad: Boolean
// showNav: Boolean
// showThumbnails: Boolean
// thumbnailsPosition: String, top, right, bottom, left
// showFullscreenButton: Boolean
// useBrowserFullscreen: Boolean
// useTranslate3D: Boolean
// showBullets: Boolean
// showIndex: Boolean
// autoPlay: Boolean
// disableThumbnailScroll: Boolean
// disableKeyDown: Boolean
// disableSwipe: Boolean
// onErrorImageURL: String, default undefined
// slideDuration: Number, default 450
// transition duration while swiping in milliseconds
// slideInterval: Number, default 3000
// slideOnThumbnailOver: Boolean, default false
// flickThreshold: Number (float), default 0.4
// onImageError: Function, callback(event)
// onThumbnailError: Function, callback(event)
// onThumbnailClick: Function, callback(event, index)
// onImageLoad: Function, callback(event)
// onSlide: Function, callback(currentIndex)
// onBeforeSlide: Function, callback(nextIndex)
// onScreenChange: Function, callback(boolean)
// onPlay: Function, callback(currentIndex)
// onClick: Function, callback(event)
// onTouchMove: Function, callback(event) on gallery slide
// onTouchEnd: Function, callback(event) on gallery slide
// onTouchStart: Function, callback(event) on gallery slide
// onMouseOver: Function, callback(event) on gallery slide
// onMouseLeave: Function, callback(event) on gallery slide